import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { shows } from "@/mocks/tv/shows";
import { getLatestShows, getPopularShows } from "@/utils/tv";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import ShowSection from "./components/ShowSection";
import TopicSection from "./components/TopicSection";

export default function Home() {
  useDocumentMeta({
    title: "绍宋影视大全-最新电影电视剧在线观看平台",
    description:
      "绍宋汇集最新电影和电视剧资源，提供丰富的影视分类和详细剧情介绍，方便用户快速查找和浏览喜欢的影视作品。",
    keywords: "绍宋,影视大全,电影,电视剧,剧情介绍,影视资源,影视平台,在线视频",
  });

  const latestShows = getLatestShows(shows, 12);
  const hotShows = getPopularShows(shows, 12);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />

      <main className="flex-1">
        <HeroCarousel />

        <section className="w-full px-4 md:px-8 pt-12 md:pt-16">
          <div className="max-w-3xl">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
              绍宋影视大全
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">
              汇集最新电影与电视剧资源，清晰的分类导航、详尽的剧情介绍，让你快速找到想看的那一部。搜索、筛选、收藏一站直达，享受纯粹的内容浏览体验。
            </p>
          </div>
        </section>

        <CategoryEntry />

        <ShowSection
          id="latest"
          eyebrow="持续更新"
          title="最新影视"
          desc="按发布日期倒序整理，第一时间掌握最新上线的电影与剧集。"
          shows={latestShows}
          viewAllHref="/category/movie"
          viewAllLabel="查看全部电影"
        />

        <div className="bg-background-100 border-y border-background-200">
          <div className="w-full max-w-[1800px] mx-auto">
            <ShowSection
              id="hot"
              eyebrow="人气飙升"
              title="热门影视推荐"
              desc="根据播放与收藏热度综合排序，看看大家都在追什么。"
              shows={hotShows}
              viewAllHref="/search?sort=popular"
              viewAllLabel="查看热度排行"
            />
          </div>
        </div>

        <TopicSection />

        <section className="w-full px-4 md:px-8 pb-14 md:pb-20">
          <div className="relative overflow-hidden rounded-lg bg-primary-900 px-6 md:px-12 py-10 md:py-14">
            <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-accent-500/15 blur-2xl" />
            <div className="relative max-w-2xl">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                关于绍宋影视
              </h2>
              <p className="mt-3 text-sm md:text-base text-primary-100 leading-7">
                绍宋是一个专注影视资源展示的内容浏览平台，致力于为影迷提供资源丰富、更新及时、分类清晰的浏览体验。所有内容均为展示演示，不提供视频播放、下载或支付功能。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap"
                >
                  <i className="ri-information-line text-lg w-5 h-5 flex items-center justify-center" />
                  了解我们
                </Link>
                <Link
                  to="/search"
                  className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap"
                >
                  开始探索
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}